'use strict';
import * as $ from 'jquery';
import { TweenMax, TimelineLite, Power0, Power2} from 'gsap';
import 'slick-carousel';

let mv: string = '#mainvisual';
let logo: string = '#mainvisual .logo';
let catchcopy: string = '#mainvisual .catch';
let items_list = '#mainvisual .service-list';
let items: string = '#mainvisual .service-list__item';
let $items: JQuery = $(items);//保存用
let itemplay: any;
let anime: SmoothAnime;



let mvInit = function () {
    TweenMax.to(mv, 1.5, { opacity: 1, scale: 1.0 });
    TweenMax.to(logo, 1, { opacity: 1, delay: 1.5 });
    TweenMax.to(catchcopy, 1.5, {
        opacity: 1,
        x: 0,
        delay: 1.5,
        ease: Power2.easeOut,
        onComplete: function () {
            //開く
            sizeChange();
            openItems();
        }
    });
    //リサイズで切り替え
    $(window).on('resize', sizeChange);

}

//サービス開く
let openItems = function () {
    let num:number = 6;
    let cnt:number = 0;
    //アイテムをランダムに並び替え
    for (var i = $items.length - 1; i >= 0; i--) {
        // 0~iのランダムな数値を取得
        var rand = Math.floor(Math.random() * (i + 1));
        // 配列の数値を入れ替える
        [$items[i], $items[rand]] = [$items[rand], $items[i]];
    }
    //アイテムを取り除く
    $(items).remove();
    //表示数だけ加える
    $items.each(function (i) {
        if (i < num) {
            $(items_list).append($(this));
            $(this).show();
        }
    });

    anime = new SmoothAnime($(items), 0.2, 0, 0);

    itemplay = TweenMax.staggerFromTo($(items), 1, {
            x:0,
            y:0
        },
        {
        cycle: {
            x: function (index) {
                var rad;
                rad = index * 60 * Math.PI / 180;
                return Math.sin(rad) * 200;
            },
            y: function (index) {
                var rad;
                rad = index * 60 * Math.PI / 180;
                return Math.cos(rad) * 200;
            },
            opacity: [1]
        },
        //paused: true,
        onComplete: function () {
            cnt++;
            //アイテム全て終了後
            if (cnt >= num) {
                setTimeout(function () {
                    anime.play();

                    //回転してから5秒後切り替え
                    setTimeout(function () {
                        changeItem();
                    }, 5000);
                }, 1000);
            }
        }
    }, 0.1);
}
//アイテムの切り替え
let changeItem = function () {
    anime.stop();
    //console.log('切り替え');
    TweenMax.to($(items),0.5, { 
        opacity: 0,
        onComplete:function(){
            //console.log($(items)); 
            TweenMax.set($(items), {
                x: 0,
                y: 0
            });
            openItems();
        }
    });
}

//画面サイズで切り替え
let sizeChange = function () {
    if (480 > $(window).width()) {
        TweenMax.to(items_list, 0.5, {
            scale: 0.6,
            y:-50
        });
        TweenMax.to(logo, 0.5, {
            scale: 0.6,
            y: -50
        });
    }
    else if (640 > $(window).width()){
        TweenMax.to(items_list, 0.5, {
            scale: 0.8
        });
        TweenMax.to(logo, 0.5, {
            scale: 1
        });
    }
    else {
        TweenMax.to(items_list, 0.5, {
            scale: 1
        });
        TweenMax.to(logo, 0.5, {
            scale: 1
        });
    }
}

//メインビジュアルの初期化
//mvInit();

//回転用クラス
class SmoothAnime {
    /**
     *
     * @param target {JQuery}
     * @param angle {Number}
     * @param center {Object}
     * @param wrapWidth {Number}
     * @param innerHeight {Number}
     * @param radius {Number}
     */
    target: JQuery;
    angle: number;
    speed: number;
    center: { x: number, y: number };
    wrapWidth: number;
    innerHeight: number;
    radius: number;
    requestId: number;
    constructor(target, speed = 0.2, wrapWidth = window.innerWidth, wrapHeight = window.innerHeight) {
        this.target = target;
        // 角度
        this.angle = 0;
        // スピード
        this.speed = speed;
        // 中心の座標
        this.center = {
            x: 0,//wrapWidth / 2 - this.target.width() / 2,
            y: 0//wrapHeight / 2 - this.target.height() / 2
        };

        //console.log(this.center);
        // 動く範囲を円の半径で表現
        // この倍の値(直径)が移動範囲になる
        this.radius = 200;//window.innerHeight / 4;
        this.requestId = 0;//requestAnimationFrameの登録用
        return this;
    }
    /**
     * ラジアンに変換する
     * @param angle
     * @returns {number}
     */
    getRadian(angle) {
        return angle * Math.PI / 180;
    }
    /**
    * アニメーションを始める
    */
    play() {
        /**
         * 円周上に配置するための値
         * @type {number}
         * @private
         */
        let _angle: number = 0;
        let main:any = this;
        this.target.each(function (i, el) {
            _angle = main.angle + (360 / main.target.length) * i;
            let x = main.center.x + Math.sin(main.getRadian(_angle)) * main.radius;
            let y = main.center.y + Math.cos(main.getRadian(_angle)) * main.radius;
            TweenMax.set(el, {
                x: x,
                y: y/*,
                z: Math.sin(main.getRadian(main.angle)) * main.radius * 2 ,
                rotationY: Math.cos(main.getRadian(main.angle + i * main.radius), -1, 1, 1, 360),
                rotationZ: Math.sin(main.getRadian(main.angle + i * main.radius), -1, 1, 1, 360) */
            });
        });

        // アニメーションで使用する角度を進める量
        // つまり、速度
        this.angle += this.speed;
        this.requestId = window.requestAnimationFrame(() => this.play());
    }
    /**
    * アニメーションを止める
    */
    stop() {
        if (this.requestId) {
            window.cancelAnimationFrame(this.requestId);
        }
    }
}


let photoInit = function () {
    const $photoList: JQuery = $('#service .photo-list');
    const ps: PhotoSlide = new PhotoSlide($photoList);
    ps.checkItem();
    ps.slide();
    $(window).on('resize', { self: ps }, ps.resize);
}


//写真スライド用Class
class PhotoSlide {
    /**
     *
     * @param target {JQuery}
     * @param itemWidth {Number}
     * @param itemNum {Number}
     */
    target: JQuery;
    items: JQuery;//アイテムを格納
    itemNum: number;//アイテム数
    itemWidth: number;//横幅
    targetTM: TimelineLite;
    speed:number;
    num:number;//複製する数
    constructor(_target) {
        this.target = _target;
        this.items = this.target.children('li');
        this.itemNum = this.items.length;
        this.itemWidth = this.items.width() * this.itemNum;
        this.targetTM = new TimelineLite();
        this.speed = 3;
        this.num = 0;
        //console.log(Math.ceil(this.itemWidth));
    }
    /**
    * スライドを始める
    */
    slide(){
        this.targetTM.clear();
        this.targetTM.fromTo(this.target, this.speed * this.itemNum, 
            {
                x:0
            },
            {
            ease: Power0.easeNone,
            x: this.itemWidth * -1,
            onComplete:this.slideComplete,
            onCompleteParams: [this]
        });
    }
    slideComplete(self){
        self.target.children('li').each(function (i) {
            if (i < self.itemNum) {
                $(this).remove();
            }
        });
        self.items.clone().appendTo(self.target);
        //console.log(self.slide);
        self.slide();
    }

    /**
    * 幅にあわせて複製・削除
    */
    checkItem() {
        let ww: number = window.outerWidth;
        let num: number = Math.ceil(ww / this.itemWidth);
        if (this.num !== num ){
            this.target.empty();
            for (let i: number = 0; i <= num; i++) {
                this.items.clone().appendTo(this.target);
            }
            this.itemWidth = this.target.children('li').width() * this.itemNum;
            this.num = num;
            this.slide();
        }
    }
    /**
    * リサイズ時
    */
    resize(e) {
        let self: PhotoSlide = e.data.self;
        self.checkItem();      
    }
}


//写真スライドの初期化
//photoInit();




function itemSliderInit() {
    var slider: Carousel = new Carousel($('#service .service-list'));
}

class Carousel {
    target:JQuery;
    constructor(_target) {
        this.target = _target;
        this.init();
    }
    init() {
        this.target.slick({
            autoplay: true,
            variableWidth: true,
            arrows: false,
            centerMode: true,
            autoplaySpeed: 2000
        });
    }
}

//アイテムスライダーの初期化
//itemSliderInit();


//スクロールアニメ
let scrollAnime = function () {
    $(window).on('scroll',function(){
        $('#mainContainer .block').each(function () {
            let elemOffset: number = $(this).offset().top;
            let scrollPos: number = $(window).scrollTop();
            let wh = $(window).height();
            if (scrollPos > elemOffset - wh + (wh / 4)) {
                $(this).addClass('isShow');
            }
        });
    });
}

//loading後
let loadingInit = function () {
    TweenMax.set(mv, { opacity: 0, scale: 1.05 });
    TweenMax.set(logo, { opacity: 0 });
    TweenMax.set(catchcopy, { opacity: 0, x: -1000 });
    $(window).on('load',function(){
        //
        scrollAnime();

        //写真スライドの初期化
        photoInit();
        //アイテムスライダーの初期化
        itemSliderInit();

        setTimeout(function(){
            $('#loading').fadeOut('fast', function () {
                mvInit();
            });
        },500)
        
    });
}

loadingInit();